import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {DialogActions, DialogContentText} from '@mui/material';
import {Grid, Button, Box} from '@material-ui/core';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import FileCopyIcon from '@mui/icons-material/FileCopy';
// import AddCircleIcon from '@mui/icons-material/AddCircle';
// import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography'; 
import AccountAddressTab from './AccountAddressTab';
import ActivitiesTable from '../activities/ActivitiesTable';
import Comments from '../comments/Comments';
import ContactsTab from '../contacts/ContactsTab';
import LeadsTab from '../leads/LeadsTab'; 
import InvoicesTab from '../invoices/InvoicesTab';
import FilesTable from '../files/FilesTable'; 
import PaymentsTab from '../payments/PaymentsTab';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';
import 'font-awesome/css/font-awesome.min.css';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>    
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const navigate = useNavigate();

  const [dataObj, setDataObj] = React.useState({});  
  const [open, setOpen] = React.useState(false); 
  const [openedTab, setOpenedTab] = React.useState('1');
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  
  const [commentList, setCommentList] = React.useState([]);
  const [activitiesList, setActivitiesList] = React.useState([]);
  const [privilegesActivities, setPrivilegesActivities] = React.useState("");
  const [clickedActivitiesTab, setClickedActivitiesTab] = React.useState(false);
  const [filesList, setFilesList] = React.useState([]);
  const [privilegesFiles, setPrivilegesFiles] = React.useState("");
  const [clickedFilesTab, setClickedFilesTab] = React.useState(false);
  const [contactsList, setContactsList] = React.useState([]);
  const [privilegesContacts, setPrivilegesContacts] = React.useState("");
  const [clickedContactsTab, setClickedContactsTab] = React.useState(false);
  const [leadsList, setLeadsList] = React.useState([]);
  const [privilegesLeads, setPrivilegesLeads] = React.useState("");
  const [clickedLeadsTab, setClickedLeadsTab] = React.useState(false);
  const [invoicesList, setInvoicesList] = React.useState([]);
  const [privilegesInvoices, setPrivilegesInvoices] = React.useState("");
  const [clickedInvoicesTab, setClickedInvoicesTab] = React.useState(false);
  const [accountAddressList, setAccountAddressList] = React.useState([]);
  const [clickedAccountAddressTab, setClickedAccountAddressTab] = React.useState(false);
  const [privilegesAccounts, setPrivilegesAccounts] = React.useState("");

  const [payments, setPayments] = React.useState([]);
  const [paymentsPrivileges, setPaymentsPrivileges] = React.useState("");
  const [clickedPaymentsTab, setClickedPaymentsTab] = React.useState(false);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    if(props.closebtn){
      setOpen(false);
    }else{
      window.close();
    }
  };

  const deleteNow = () => {
    setDeleteDialogShow(false);
  };

  function deleteDialogHide(){
		setDeleteDialogShow(false);
	}


  React.useEffect(() => {
    setOpenedTab('1');
    
    setAccountAddressList([]);
    setClickedAccountAddressTab(false);
    
    setActivitiesList([]);
    setClickedActivitiesTab(false);
    
    setFilesList([]);
    setClickedFilesTab(false);
    
    setContactsList([]);
    setClickedContactsTab(false);
    setPrivilegesContacts("");
    
    setLeadsList([]);
    setClickedLeadsTab(false);
    setPrivilegesLeads("");
    
    setInvoicesList([]);
    setClickedInvoicesTab(false);
    setPrivilegesInvoices("");

    setPayments([]);
    setClickedPaymentsTab(false);
    setPaymentsPrivileges("");
      
    if(open){ // only on open state
      if(props.dataObj && props.dataObj.autoId>0){
        setDataObj(props.dataObj);
        setPrivilegesAccounts(props.privileges);
        getApiDataComments(props.dataObj.autoId);
      }else if(props.accountId && props.accountId>0){
        getApiData();        
      }
      
    }    
	}, [open]);

  const handleChangeTabs = (event, newValue) => { 
    if(newValue==='2' && !clickedContactsTab){
      getApiDataContacts();
      setClickedContactsTab(true);
    }else if(newValue==='3' && !clickedLeadsTab){
      getApiDataLeads();
      setClickedLeadsTab(true);
    }else if(newValue==='5' && !clickedInvoicesTab){
      getApiDataInvoices();
      setClickedInvoicesTab(true);
    }else if(newValue==='6' && !clickedActivitiesTab){
      getApiDataActivities();
      setClickedActivitiesTab(true);
    }else if(newValue==='7' && !clickedFilesTab){
      getApiDataFiles();
      setClickedFilesTab(true);
    }else if(newValue==='8' && !clickedAccountAddressTab){
      getApiDataAccountAddress();
      setClickedAccountAddressTab(true);
    }else if(newValue==='9' && !clickedPaymentsTab){
      getApiDataPayments();
      setClickedPaymentsTab(true);
    }
  
    setOpenedTab(newValue);
  };

  async function getApiData(){ 
    let apiUrl=API_URL+'/crm-list-accounts?accountId='+props.accountId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
      .then(response => {
      // setDataLoading(false);
      if(response && response.data && response.data.responseTxt==="success"){  
        if(response.data.list && response.data.list.length>0){
          setDataObj(response.data.list[0]);
          getApiDataComments(response.data.list[0].autoId);	 /// calls comments list after fetching account details
        }								 				
        setPrivilegesAccounts(response.data.privileges);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        window.location.href='invalidtoken';
      }else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
        //childRefAuthorization.current.handleClickOpen();
      }
    }).catch((error) => {
      })	
  }


  async function getApiDataComments(accountId){ 

    let apiUrl=API_URL+'/crm-comments-cache?relatedTo=Account&relatedToId='+accountId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
          setCommentList(response.data.list);	
      }else if(response && response.data && response.data.responseTxt==="failed"){  
          setCommentList([]);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
      }
    })
  }

  async function getApiDataContacts(){ 
    let apiUrl=API_URL+'/crm-list-contacts?accountId='+dataObj.autoId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
        setContactsList(response.data.list);	
        setPrivilegesContacts(response.data.privileges);
      }else if(response && response.data && response.data.responseTxt==="failed"){  
        setContactsList([]);
        setPrivilegesContacts("");
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
      }
    })
  }

  async function getApiDataLeads(){ 
    let apiUrl=API_URL+'/crm-list-leads?accountId='+dataObj.autoId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
        setLeadsList(response.data.list);	
        setPrivilegesLeads(response.data.privileges);
      }else if(response && response.data && response.data.responseTxt==="failed"){  
        setLeadsList([]);
        setPrivilegesLeads("");
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
      }
    })
  }

  async function getApiDataInvoices(){ 
    let apiUrl=API_URL+'/crm-list-invoices?accountId='+dataObj.autoId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
        setInvoicesList(response.data.list);	
      }else if(response && response.data && response.data.responseTxt==="failed"){  
        setInvoicesList([]);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
      }
    })
  }

  async function getApiDataActivities(){ 
    let apiUrl=API_URL+'/crm-cache-activity?relatedTo=Account&relatedToId='+dataObj.autoId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
        ///document.write(JSON.stringify(response.data));
      if(response && response.data && response.data.responseTxt==="success"){  
        setActivitiesList(response.data.list);
        setPrivilegesActivities(response.data?.privileges);	
      }else if(response && response.data && response.data.responseTxt==="failed"){  
        setActivitiesList([]);
        setPrivilegesActivities([]);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
      }
    })
  }

  async function getApiDataFiles(){ 
    let apiUrl=API_URL+'/crm-cache-files?relatedTo=Account&relatedToId='+dataObj.autoId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
        setFilesList(response.data.list);	
        setPrivilegesFiles(response.data.privileges);
      }else if(response && response.data && response.data.responseTxt==="failed"){  
        setFilesList([]);
        setPrivilegesFiles("");
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
      }
    })
  }

  async function getApiDataAccountAddress(){ 
    let apiUrl=API_URL+'/crm-account-address-cache?accountId='+dataObj.autoId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
      .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
        setAccountAddressList(response.data.list);	
      }else if(response && response.data && response.data.responseTxt==="failed"){  
        setAccountAddressList([]);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        navigate('/invalidtoken');
      }
    })
  }

  async function getApiDataPayments(){ 
    let apiUrl=API_URL+'/crm-list-payments?relatedTo=Account&relatedToId='+dataObj.autoId;
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'registerId': props.userObj.registerId,
        'uid': props.userObj.loginId,
        'fullName': props.userObj.fullName,
        'token': props.userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    await axios(config)
       .then(response => {
      if(response && response.data && response.data.responseTxt==="success"){  
        setPayments(response.data.list);
        setPaymentsPrivileges(response.data.privileges);	
      }else if(response && response.data && response.data.responseTxt==="failed"){  
        setPayments([]);
      }else if(response && response.data && response.data.responseTxt==="invalidtoken"){
        window.location.href='invalidtoken';
      }
    })
  }


  function accountAddressUpdatedList(list) {
    setAccountAddressList(list);
  }
  function filesUpdatedList(list) {
    setFilesList(list);
  }
  function activitiesUpdatedList(list) {
    setActivitiesList(list);
  }
  function invoicesUpdatedList(list) {
    setInvoicesList(list);
  }
  function leadsUpdatedList(list) {
    setLeadsList(list);
  }
  function contactsUpdatedList(list) {
    setContactsList(list);
  }
  function comments(list){
    setCommentList(list);	
  }
  function paymentsList(list) {
    setPayments(list);
  }

  return (dataObj?
    <>
      <Dialog fullScreen style={{margin:5}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-45px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'88vh'}}>
            <Grid item md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{dataObj.accountName}</h3></div>
                  <p>
                  <Box>

                    {/* <div style={{textAlign:'center',marginTop:-12,marginBottom:3}}>
                        <EditIcon style={{marginRight:10,color:'#2c7eea'}} />
												<DeleteIcon style={{marginRight:10,color:'#2c7eea'}} />
												<FileCopyIcon style={{marginRight:10,color:'#2c7eea'}} />
												<AddCircleIcon style={{marginRight:10,color:'#2c7eea'}} />
												<VisibilityIcon style={{marginRight:10,color:'#2c7eea'}} />
                    </div> */}

						<Grid container style={{marginTop:-10}} >
                <Grid item md={6} xs={12} >
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Account Number
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.accountNumber}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Unique Account Name
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.accountName}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Company
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.company}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Address
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.address} {dataObj.city} {dataObj.zipCode} {dataObj.state} {dataObj.country}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        GST Number
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.gstNumber}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        PAN Number
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.panNumber}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Aadhaar Number
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.aadhaarNumber}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Corporate Identification Number (CIN)
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.cin}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Consignee Code
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.consigneeCode}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Type of Company
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.companyType}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Year of Registeration
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.registrationYear}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Sales Turnover
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.turnover}
                      </Grid>
                    </Grid>


                </Grid>    
                <Grid item md={6} xs={12} >
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Category
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.accountCategory}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Products & Services Sell
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.products}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Rank
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.rank}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Purchase Potential
                      </Grid>
                      <Grid item xs={9}>
                        {(dataObj.purchasePotential>0)?<><span className='fa fa-inr' /> {dataObj.purchasePotential.toLocaleString('en-IN')}</>:null}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Actual Purchase
                      </Grid>
                      <Grid item xs={9}>
                        {(dataObj.purchaseActual>0)?<><span className='fa fa-inr' /> {dataObj.purchaseActual.toLocaleString('en-IN')}</>:null}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Website
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.website}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Credit Days
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.creditDays>0?dataObj.creditDays:null}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Tags
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.tags}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Industry
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.industry}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Agent
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.ownerAlias} {dataObj.accessWithNames?<>,{dataObj.accessWithNames}</>:null}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Visibility
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.accessTypeTitle}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Created By
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.createdAlias} {dataObj.createdDateTime}
                      </Grid>
                    </Grid>
                    <Grid container className="btmbdrgry" >
                      <Grid item xs={3}>
                        Last Modified By
                      </Grid>
                      <Grid item xs={9}>
                        {dataObj.lastModifiedAlias} {dataObj.lastModifiedDateTime}
                      </Grid>
                    </Grid>
                </Grid>

						</Grid>
					</Box>                      

          <Box style={{ width: '100%', typography: 'body1', marginTop: 10 }}>
										<TabContext value={openedTab}>
											<Box sx={{ borderBottom: 1, borderColor: 'divider', display:'flex', justifyContent:'center' }}>
											<TabList onChange={handleChangeTabs} variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
                        <Tab label="Comments" value="1" />
                        <Tab label="Contacts" value="2" />
                        <Tab label="Leads" value="3" />
                        <Tab label="Invoices" value="5" />
                        <Tab label="Activities" value="6" />
												<Tab label="Files" value="7" />
                        <Tab label="Address" value="8" />
                        <Tab label="Payments" value="9" />
											</TabList>
											</Box>
											<TabPanel value="1">
                        {/* Comments */} 
                         <Comments relatedTo={'Account'} relatedToId={dataObj.autoId} showToCustomer={false} rows={commentList} userObj={props.userObj} comments={comments} /> 
                      </TabPanel>
											<TabPanel value="2">
                        {/* Contacts */} 
                         <ContactsTab accountObj={dataObj} rows={contactsList} privileges={privilegesContacts} userObj={props.userObj} contactsUpdatedList={contactsUpdatedList} /> 
                      </TabPanel>
											<TabPanel value="3">
                        {/* Leads */} 
                         <LeadsTab accountId={dataObj.autoId} rows={leadsList} privileges={privilegesLeads} userObj={props.userObj} leadsUpdatedList={leadsUpdatedList} /> 
                      </TabPanel>
											<TabPanel value="5">
                        {/* Invoices */} 
                         <InvoicesTab accountId={dataObj.autoId} rows={invoicesList} privileges={privilegesInvoices} userObj={props.userObj} invoicesUpdatedList={invoicesUpdatedList} /> 
                      </TabPanel>
											<TabPanel value="6"> 
                        {/* Activities */}
                        <ActivitiesTable relatedTo='Account' relatedToId={dataObj.autoId} relatedTitle={dataObj.accountName} userObj={props.userObj} rows={activitiesList} privilegesActivities={privilegesActivities} activitiesUpdatedList={activitiesUpdatedList}  /> 
                      </TabPanel>
											<TabPanel value="7">
                        {/* Files */}
                        <FilesTable relatedTo='Account' relatedToId={dataObj.autoId} relatedTitle={dataObj.accountName} userObj={props.userObj} rows={filesList} privilegesFiles={privilegesFiles} filesUpdatedList={filesUpdatedList} /> 
                      </TabPanel>
                      <TabPanel value="8">
                        {/* Account Address */}
                        <AccountAddressTab accountId={dataObj.autoId} ownerId={dataObj.ownerId} privileges={privilegesAccounts} userObj={props.userObj} rows={accountAddressList} accountAddressUpdatedList={accountAddressUpdatedList} /> 
                      </TabPanel>
                      {/* PAYMENTS */}
                      <TabPanel value="9">
                        <PaymentsTab privileges={paymentsPrivileges} relatedTo={'Account'} relatedDataObj={dataObj} userObj={props.userObj} rows={payments} paymentsList={paymentsList} /> 
                      </TabPanel>

										</TabContext>
									</Box>


                  </p>
            </Grid>
          </DialogContent>
      </Dialog>


        <Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete student course.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteNow()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>


    </>:null
  );

});

export default CustomizedDialogs;